import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { RecordListCardComponent } from '../record-list/record-list.types';

@Component({
  selector: 'app-project-card',
  standalone: false,
  templateUrl: './project-card.html',
  styleUrl: './project-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectCard implements RecordListCardComponent {
  @Input({ required: true }) item: Record<string, unknown> = {};
  @Input() context: Readonly<Record<string, unknown>> = {};

  get name(): string { return String(this.item['name'] ?? 'Untitled Project'); }
  get memberCount(): number { return Number(this.item['member_count'] ?? 0); }
  get branchCount(): number { return Array.isArray(this.item['branch_ids']) ? this.item['branch_ids'].length : 0; }
  get progress(): number { return Math.max(0, Math.min(100, Number(this.item['progress'] ?? 0))); }
}
